// CANONICAL COPY (GH #7115). src/constants/obligations/obl-clear-desk-screen.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-clear-desk-screen',
  title: 'Verify clear desk and clear screen controls',
  description:
    'Confirm that clear desk rules for papers and removable storage media, and clear screen rules for information processing facilities, are defined, communicated and enforced. Automatic session locking shall be configured on enterprise assets after a defined period of inactivity.',
  category: 'people',
  scfIds: ['SCF-PHY-007'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Clear desk / clear screen policy is published' },
    {
      type: 'document-acknowledged',
      description: 'All required readers have acknowledged the policy',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
